<template>
    <a-select :mode="props.mode" v-model:value="state.value" :placeholder="props.placeholder" @change="changeValue"
        option-filter-prop="label" allow-clear>
        <a-select-opt-group v-for="(item, index) in state.platformList" :key="index" :label="item.label">
            <a-select-option v-for="(son, idx) in item.children" :key="idx + '_' + index" :value="son.buss_id">
                {{ item.label }}_{{
                    son.platform_name
                }}</a-select-option>
        </a-select-opt-group>
    </a-select>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
    value: {
        type: [String, Array],
        default: []
    },
    placeholder: {
        type: String,
        default: '请选择业务平台'
    },
    mode: {
        //multiple 是多选，undefined是单选
        type: String,
        default: undefined
    }
})
const state = reactive<any>({
    platformList: [],
    value: null
})
onMounted(() => {
    if (props.mode == 'multiple') {
        if (props.value && Array.isArray(props.value)) {
            state.value = props.value.map(String)
        } else {
            state.value = []
        }
    } else {
        if (props.value) {
            state.value = String(props.value)
        } else {
            state.value = null
        }
    }
    platformList()
})
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/busstype/bussplatform',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
//改变值
const changeValue = (value: any) => {
    emit('update:value', state.value)
    emit('change', state.value)
}
watch(
    () => props.value,
    (val) => {
        if (val) {
            if (props.mode == 'multiple') {
                if (props.value && Array.isArray(props.value)) {
                    state.value = props.value.map(String)
                } else {
                    state.value = []
                }
            } else {
                if (props.value) {
                    state.value = String(props.value)
                } else {
                    state.value = null
                }
            }
        }
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
